<div mat-dialog-title>
  <div class="title-icon">
    <mat-icon>dvr</mat-icon>
  </div>
  <div class="title-text">{{ 'display.title' | transloco }}</div>
</div>
<mat-dialog-content class="mat-typography">
  <form #f="ngForm">
    <div class="form-group">
      <label for="font-size">{{ 'display.font_size' | transloco }}</label>
      <div class="row font-size-slider">
        <div class="col-2 font-size-slider__small">A</div>
        <div class="col-8 font-size-slider__input">
          <ngx-slider
            [value]="fontSize$ | async"
            (valueChange)="changeFontSize($event)"
            [options]="sliderOptions"
            [manualRefresh]="manualRefreshEmitter">
          </ngx-slider>
        </div>
        <div class="col-2 font-size-slider__big">A</div>
      </div>
      <label for="font-weight">{{ 'display.font_weight' | transloco }}</label>
      <div class="row font-size-slider">
        <div class="col-2 text-center">
          <span style="font-weight: 100; font-size: 36px;">A</span>
        </div>
        <div class="col-8 font-size-slider__input">
          <ngx-slider
            [value]="fontWeight$ | async"
            (valueChange)="changeFontWeight($event)"
            [options]="fontWeightSliderOptions"
            [manualRefresh]="manualRefreshEmitter">
          </ngx-slider>
        </div>
        <div class="col-2 text-center">
          <span style="font-weight: 900; font-size: 36px;">A</span>
        </div>
      </div>
      <label for="font-size">{{ 'display.text_width' | transloco }}</label>
      <div class="row font-size-slider">
        <div class="col-2 font-size-slider__small">
          <mat-icon>width_full</mat-icon>
        </div>
        <div class="col-8 font-size-slider__input">
          <ngx-slider
            [value]="viewportWidth$ | async"
            (valueChange)="changeViewportWidth($event)"
            [options]="sliderOptions"
            [manualRefresh]="manualRefreshEmitter">
          </ngx-slider>
        </div>
        <div class="col-2 font-size-slider__big">
          <mat-icon>width_wide</mat-icon>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="theme">{{ 'display.theme' | transloco }}</label>
      <select
        [(ngModel)]="currentTheme"
        name="theme"
        (ngModelChange)="changeTheme()"
        id="theme"
        class="custom-select">
        @for (theme of themes; track theme) {
          <option [value]="themeList[theme]">
            {{ theme }}
          </option>
        }
      </select>
    </div>
    <div class="form-group">
      <div class="darkmode-toggle-group">
        <label for="dark-mode" class="darkmode-label">{{ 'display.dark_mode' | transloco }}</label>
        <mat-slide-toggle
          id="dark-mode"
          [checked]="darkMode$ | async"
          (change)="toggleDarkMode()"
          class="custom-darkmode-toggle">
        </mat-slide-toggle>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'display.close' | transloco }}</button>
</mat-dialog-actions>
